import { Flex, Tag, Text, Textarea } from '@chakra-ui/react';

export const NOTE_MAX_LENGTH = 1000;

export const isCounterNoteValid = (note: string) => note.trim().length >= 2;

type CounterNoteFieldProps = {
  note: string;
  onNoteChange: (note: string) => void;
};

// The required note that travels with a counter so it carries a reason, not just a number.
const CounterNoteField = ({ note, onNoteChange }: CounterNoteFieldProps) => (
  <>
    <Flex align="center" gap="8px" mt="16px" mb="8px">
      <Text fontSize="13px" fontWeight="600" color="leaseEndBlue">
        Add a note to the buyer
      </Text>
      <Tag
        size="sm"
        bg="iceBlue"
        color="oceanBoatBlue"
        fontSize="10px"
        fontWeight="700"
        textTransform="uppercase"
        letterSpacing="0.05em"
        borderRadius="5px"
      >
        Required
      </Tag>
    </Flex>
    <Textarea
      aria-label="Add a note to the buyer"
      value={note}
      onChange={(event) => onNoteChange(event.target.value)}
      placeholder="Add context, ask a question, or explain your number."
      maxLength={NOTE_MAX_LENGTH}
      rows={3}
      resize="none"
      fontSize="14px"
      borderRadius="12px"
      borderColor="gainsboro"
      _placeholder={{ color: 'gray.500' }}
      _focusVisible={{ borderColor: 'leaseEndBlue', boxShadow: 'none' }}
    />
  </>
);

export default CounterNoteField;
